const apiHost =
    process.env.INTERNAL_MONOLITH_HOST || process.env.API_HOST || '';
export default function getMonolithHost() {
    return apiHost;
}
